import { useCallback, useRef, useState } from "react";

const useSMSSentButtonFeedback = () => {
  const [sentFeedbackApplied, setSentFeedbackApplied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const clearTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  const resetTimer = useCallback(() => {
    clearTimer();
    timeoutRef.current = setTimeout(() => {
      setSentFeedbackApplied(false);
    }, 5000);
  }, [clearTimer, setSentFeedbackApplied]);

  const applySentFeedback = useCallback(() => {
    setSentFeedbackApplied(true);
    resetTimer();
  }, [resetTimer, setSentFeedbackApplied]);

  const clearSentFeedback = useCallback(() => {
    setSentFeedbackApplied(false);
    clearTimer();
  }, [clearTimer, setSentFeedbackApplied]);

  return { sentFeedbackApplied, applySentFeedback, clearSentFeedback };
};

export default useSMSSentButtonFeedback;
